import { capitalizeIfLower, formatAddressToObj, formatDate, parseBoolean } from '@btime/helpers'
import { prop, type } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { hasValue } from '../../utils/helpers/value'
import StockItemTooltip from './stock/StockItemTooltip'
import TextWithoutOverflow from '../../packages/kiti/components/presentation/TextWithoutOverflow'

const renderValue = (value, valueType, t) => {
  if (value === null) {
    return t('common:notAvailable')
  }

  switch (valueType) {
    case 'compliance':
    case 'checkbox':
      const active = parseBoolean(value)
      return active ? t('common:yes') : t('common:no')

    case 'multiple':
      return value.map(prop('name')).join(', ')

    case 'pending':
      const pendencyName = capitalizeIfLower(value?.name)

      return pendencyName

    case 'datetime':
      return formatDate('DD/MM/YYYY HH:mm', value)

    case 'date':
      return formatDate('DD/MM/YYYY', value)

    case 'select':
      return value?.name

    case 'system_status':
      return value ? t('common:active') : t('common:inactive')

    case 'sign':
      return value?.name

    case 'gallery':
      return t('common:documentsCount', { count: value?.length || 0 })

    case 'address':
    case 'location':
      value = formatAddressToObj(value)
      return prop(['search'], value)

    case 'asset':
    case 'place':
    case 'user':
      return value?.name || value?.map(prop('name')).join(', ')

    case 'place_location':
    case 'place_person':
      return value?.map(prop('name')).join(', ')

    case 'action_plan':
      return t('common:actionPlansCount', { count: value?.length || 0 })

    case 'informative':
      return false

    case 'stock':
      return <StockItemTooltip value={value} />

    default:
      const dataType = type(value)
      if (dataType === 'Object' || dataType === 'Array') {
        return `**${t('common:fieldInDevelopment')}**`
      }
      return (hasValue(value) ? value : '').toString()
  }
}

const DynamicPresentationText = ({ value, type, ...props }) => {
  const { t } = useTranslation('common')
  if (value === undefined) return false
  if (type === 'stock') return renderValue(value, type, t)

  return (
    <TextWithoutOverflow size="small" {...props}>
      {renderValue(value, type, t)}
    </TextWithoutOverflow>
  )
}

export default DynamicPresentationText
